// you can import modules from the theme lib or even from
// NPM packages if they support it…
import ExampleComponent1 from "./components/ExampleComponent1";

// you can also require modules if they support it…
// const ExampleModule2 = require('./components/example-2');

// Some convenient tools to get you started…
import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
import AnimateOnPageLinks from "./components/AnimateOnPageLinks";

import Vue from 'vue';
import Motion from 'tinymotion';
import {
    VueMasonryPlugin
} from 'vue-masonry';

// Vue Range picker - https://github.com/mengxiong10/vue2-datepicker
import DatePicker from 'vue2-datepicker';
Vue.use(VueMasonryPlugin);

// import axios from "axios";

// import VueAxios from "vue-axios";
// Vue.use(VueAxios, axios);

// LazyLoad - https://github.com/aFarkas/lazysizes
import 'lazysizes';
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

//Mansonry
// import Masonry from "masonry-layout";


//GMaps
import {
    Loader
} from '@googlemaps/js-api-loader';

const fSmoothScroll = require('./utils/smooth-scroll');
const fNavMenu = require('./components/NavbarMenu');
const fCarousels = require('./components/Carousels');
const fScrollDownBtn = require('./components/ScrollDownBtn');
const fDocumentsExpander = require('./components/DocumentsExpander');
const fGoogleMaps = require('./components/GoogleMaps');
const fPageSearch = require('./components/PageSearch');

const InitVueComponents = function () {
    // Vue stuff
    Vue.component('motion', Motion);
    Vue.component('date-picker', DatePicker);

    Vue.component(
        'dropdown',
        require('./vue/Dropdown.js').default
    );

    Vue.component(
        'pagination',
        require('./vue/Pagination.js').default
    );

    Vue.component(
        'slide-post-list',
        require('./vue/SlidePostList.js').default
    );

    Vue.component(
        'involved-posts',
        require('./vue/InvolvedPosts.js').default
    );

    Vue.component(
        'search-results',
        require('./vue/SearchResults.js').default
    );

    Vue.component(
        'category-discover',
        require('./vue/CategoryDiscover.js').default
    );

    Vue.component(
        'events-posts',
        require('./vue/EventsPosts.js').default
    );

    Vue.component(
        'mansonry-posts',
        require('./vue/MansonryPosts.js').default
    );

    Vue.component(
        'item-listing',
        require('./vue/ItemListing.js').default
    );

    Vue.component(
        'todo-posts',
        require('./vue/ToDoPosts.js').default
    );

    Vue.component(
        'todo-list',
        require('./vue/ToDoList.js').default
    );

    Vue.component(
        'events-list',
        require('./vue/EventsList.js').default
    );

    Vue.component(
        'discover-list',
        require('./vue/DiscoverList.js').default
    );

    Vue.component(
        'cpt-category-list',
        require('./vue/CptCategoryList.js').default
    );

    Vue.component(
        'post-list',
        require('./vue/PostList.js').default
    );

    new Vue({
        el: document.getElementById('vue-space')
    });
}


// Initialise our components on jQuery.ready…
jQuery(function ($) {
    // ExampleComponent1.init();
    // ExampleModule2.init();
    // ReplaceObfuscatedEmailAddresses.init();
    // AnimateOnPageLinks.init();

    fSmoothScroll();
    fNavMenu();
    fGoogleMaps(Loader);
    fCarousels(Swiper);
    fScrollDownBtn();
    fDocumentsExpander();
    fPageSearch();
    InitVueComponents();
});

import './templates/campaign';